import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/transhumans/jumping-air.png")